import { createRouter, createWebHashHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import PaperList from '../views/quiz/PaperList.vue'
import PaperDetail from '../views/quiz/PaperDetail.vue'
import TrainMode from '../views/quiz/TrainMode.vue'
import TrainModeEN from '../views/quizen/TrainMode.vue'
import PaperListEN from '../views/quizen/PaperList.vue'
import PaperDetailEN from '../views/quizen/PaperDetail.vue'

import * as storage from '@/utils/storage'

const routes = [
  { path: '/', redirect: '/quiz/paper', meta: {title: '首页'} },
  { path: '/login', name:'LoginPage', component: LoginPage, meta: {title: '登录'}},
  { path: '/home', name:'Home', component: PaperList, meta: { requiresAuth: true, title: '我的试卷' }},
  { path: '/quiz', name:'QuizHome', component: PaperList, meta: { requiresAuth: true, title: '我的试卷' }},
  { path: '/quiz/paper', name:'PaperList', component: PaperList, meta: { requiresAuth: true, title: '我的试卷' }},
  { path: '/quiz/paper/:id', name:'PaperDetail', component: PaperDetail, meta: { requiresAuth: true, title: '试卷详情' }},
  { path: '/quiz/train', name:'TrainMode', component: TrainMode, meta: { requiresAuth: true, title: '训练模式' }},
  { path: '/quiz/en', name:'QuizHomeEN', component: PaperListEN, meta: { requiresAuth: true, title: 'My Papers' }},
  { path: '/quizen/paper', name:'PaperListEN', component: PaperListEN, meta: { requiresAuth: true, title: 'My Papers' }},
  { path: '/quizen/paper/:id', name:'PaperDetailEN', component: PaperDetailEN, meta: { requiresAuth: true, title: 'Paper Details' }},
  { path: '/quizen/train', name:'TrainModeEN', component: TrainModeEN, meta: { requiresAuth: true, title: 'Train Mode' }},
]

const router = createRouter({
  history: createWebHashHistory(), // 使用 HTML5 历史模式。你也可以使用 hash 模式。
  routes // 短语法，等同于 routes: routes。
})

router.beforeEach((to, from, next) => {
    const isLogin = storage.get('isLogin') === 'true';

    if (to.meta.requiresAuth && !isLogin) {
        localStorage.setItem('redirectPath', to.fullPath || '/home');
        next('/login');
    } else {
        next();
    }
});

router.afterEach((to) => {
  document.title = to.meta.title || '';
});

export default router;